import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "order-side"
}
const _hoisted_2 = {
  key: 1,
  class: "order-side"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderSide',
  props: {
  isBuy: { type: Boolean, required: true },
  isFutures: { type: Boolean, default: false },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.isBuy)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.isFutures ? _ctx.$t('fundamentals.orders.side.long') : _ctx.$t('fundamentals.orders.side.buy')), 1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.isFutures ? _ctx.$t('fundamentals.orders.side.short') : _ctx.$t('fundamentals.orders.side.sell')), 1))
}
}

})